<template>
    <div>
    <b-navbar fixed="top" toggleable="lg" type="light" variant="light">
        <b-navbar-brand target="_blank" href="#"><img src="images/landscape.png" alt=""></b-navbar-brand>
        <b-nav-text> Customer Portal</b-nav-text>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
      

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="authenticated">
            
            
            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Webcasting</em></template>
              <b-dropdown-item v-on:click='_menuSelect("editStream")'>View Streams</b-dropdown-item>
              <b-dropdown-item v-on:click='_menuSelect("addStream")'>New Stream</b-dropdown-item>
              
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Cash Sales</em></template>
              <b-dropdown-item v-on:click='_menuSelect("posOrder")'>Add Order</b-dropdown-item>
              
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Distribution</em></template>
              <b-dropdown-item href="https://www.aperturefilms.com.au/customer-portal/labels.html">Print Labels <em class="small">(use Firefox)</em></b-dropdown-item>
              <b-dropdown-item href="https://www.aperturefilms.com.au/customer-portal/emails.php">Get Email CSV</b-dropdown-item>
              <b-dropdown-item href="https://www.aperturefilms.com.au/customer-portal/usb.php">Get USB CSV</b-dropdown-item>
              
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Select Performance</em></template>
              <b-dropdown-item v-for="performance in performances" :key="performance.id" v-on:click="setPerformance(performance.performance_id)" >{{performance.performance_id}} - {{performance.name}}</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Performances</em></template>
              <b-dropdown-item v-on:click='_menuSelect("performanceEdit")'>Edit</b-dropdown-item>
              <b-dropdown-item v-on:click='_menuSelect("addPerformance")'>Add</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right v-if="admin">
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Users</em></template>
              <b-dropdown-item v-on:click='_menuSelect("editUsers")'>Edit</b-dropdown-item>
              <b-dropdown-item v-on:click='_menuSelect("addUser")'>Add</b-dropdown-item>
            </b-nav-item-dropdown>


            <b-nav-item-dropdown right >
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Profile</em></template>
              <b-dropdown-item v-on:click='passwordMenu'>Change Password</b-dropdown-item>
              <b-dropdown-item v-on:click='SignOut'>Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    </div>
</template>

<script>
/* eslint-disable */ 

export default {
    name: "NavMenu",
    data() {
      return {
        performances: '',
      }
    },
    props: {
      authenticated: false,
      admin: false,
    },
    methods: {
      setPerformance(_performance) {
        this.$emit('refresh', true)
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'setPerformance');
        params.append('performance_id', _performance);
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    currentObj.$emit('refresh', false)
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      listPerformance() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'listPerformances');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
        
                    currentObj.performances = response.data
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
     

      SignOut(evt) {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('logout', true);
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/login.php', params)
                .then(function (response) {
                    currentObj.$emit('authenticated', response.data)
                })
                .catch(function (error) {
                    console.log(error);  
                });
        },
        _menuSelect(_item) {
          this.$emit('menuItem', _item)
        },
        passwordMenu(evt) {
          this.$emit('passwordMenu', true)
        }
    },
    mounted() {
      
       // this.listPerformance()
    },
     watch: {
        // whenever question changes, this function will run
        authenticated: function () {
          if (this.authenticated) {
            this.listPerformance()  
        } }
      },
}
</script>

<style scoped>
img {
    width:250px;
 
}
</style>
